import './Tooltip.scss';

import React from 'react';
import MuiTooltip from '@material-ui/core/Tooltip/Tooltip';
import { useIsEmbedded } from 'hooks/useIsEmbedded';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';

const { cx } = cxHelpers('Tooltip');

const Tooltip = ({ className, children, title, ...props }) => {
  const isEmbedded = useIsEmbedded();

  return title ? (
    <MuiTooltip
      classes={{ popper: cx({ isEmbedded }, className) }}
      title={title}
      {...props}
    >
      {children}
    </MuiTooltip>
  ) : (
    children
  );
};

Tooltip.propTypes = {
  className: PropTypes.string,
  placement: PropTypes.string,
};

Tooltip.defaultProps = {
  placement: 'top',
};

export default Tooltip;
